import Alpine from 'alpinejs';
import { Product } from '../types/types';

export const AlpineDataToast = () => Alpine.data('cartToast', () => ({
  showToast: false,
  toastProduct: null,
  toastTimeoutId: null,

  doShowToast(prod: Product) {
    // Show confirmation toast
    this.toastProduct = prod;
    this.showToast = true;

    // Clear any existing timeout
    if (this.toastTimeoutId) {
      clearTimeout(this.toastTimeoutId);
    }

    // Auto-hide toast after 30 seconds
    this.toastTimeoutId = setTimeout(() => {
      this.hideToast();
    }, 30000);
  },

  hideToast() {
    this.showToast = false;
    this.toastProduct = null;
    if (this.toastTimeoutId) {
      clearTimeout(this.toastTimeoutId);
    }
  },

  continueShoppingHandler() {
    this.hideToast();
  },

  viewCartHandler() {
    window.location.href = '/cart';
  }

}));
